// Ventana del 10 % de bienvenida (snippets/rv-promo-popup.liquid). 17-10-2026.
(() => {
  const popup = document.getElementById('rv-promo');
  if (!popup) return;
  if (window.Shopify && window.Shopify.designMode) return;

  const KEY_DONE = 'rv_promo_done';
  const KEY_CLOSED = 'rv_promo_closed_at';
  const WAIT_MS = 10000;
  const SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;

  // localStorage puede fallar (modo privado, bloqueos): sin él la ventana sigue funcionando.
  const store = {
    get: (key) => { try { return localStorage.getItem(key); } catch (e) { return null; } },
    set: (key, value) => { try { localStorage.setItem(key, value); } catch (e) { /* nada */ } },
  };

  const gate = document.getElementById('rv-age-gate');
  const gateOpen = () => !!gate && gate.style.display !== 'none' && !gate.classList.contains('is-hidden');

  let lastFocus = null;

  const focusables = () =>
    Array.from(popup.querySelectorAll('button, input:not([type="hidden"]), a[href]')).filter((el) => !el.disabled);

  const open = () => {
    lastFocus = document.activeElement;
    popup.hidden = false;
    document.documentElement.classList.add('rv-pm-open');
    requestAnimationFrame(() => popup.classList.add('is-open'));
    const first = popup.querySelector('.rv-pm__input') || popup.querySelector('.rv-pm__close');
    if (first) first.focus({ preventScroll: true });
  };

  const close = () => {
    popup.classList.remove('is-open');
    popup.hidden = true;
    document.documentElement.classList.remove('rv-pm-open');
    if (!store.get(KEY_DONE)) store.set(KEY_CLOSED, String(Date.now()));
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };

  popup.addEventListener('click', (event) => {
    if (event.target === popup || event.target.closest('[data-rv-promo-close]')) close();
  });

  document.addEventListener('keydown', (event) => {
    if (popup.hidden) return;
    if (event.key === 'Escape') {
      close();
      return;
    }
    // El foco no sale de la ventana mientras está abierta.
    if (event.key === 'Tab') {
      const items = focusables();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  // Vuelta de un envío del formulario (Shopify añade ?customer_posted=true).
  const succeeded = !!popup.querySelector('[data-rv-promo-success]');
  const failed = !!popup.querySelector('.rv-pm__error');
  const fromPopup = window.location.hash === '#rv-promo-form';
  if (succeeded) store.set(KEY_DONE, '1');
  if (fromPopup && (succeeded || failed)) {
    open();
    return;
  }

  if (store.get(KEY_DONE)) return;
  const closedAt = parseInt(store.get(KEY_CLOSED) || '0', 10);
  if (closedAt && Date.now() - closedAt < SNOOZE_MS) return;

  // 10 s en la página, contados desde que se pasa la verificación de edad. Si al cumplirse la
  // pestaña está en segundo plano, se espera a que vuelva a estar visible.
  const tick = () => {
    if (gateOpen() || document.hidden) {
      setTimeout(tick, 1000);
      return;
    }
    open();
  };
  const startTimer = () => setTimeout(tick, WAIT_MS);
  const yes = document.getElementById('rv-age-yes');
  if (gateOpen() && yes) {
    yes.addEventListener('click', startTimer, { once: true });
  } else {
    startTimer();
  }
})();
